import { render } from "./TicketApply.vue?vue&type=template&id=cfae4804&scoped=true"
import script from "./TicketApply.vue?vue&type=script&lang=js"
export * from "./TicketApply.vue?vue&type=script&lang=js"

import "./TicketApply.vue?vue&type=style&index=0&id=cfae4804&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfae4804"]])

export default __exports__